module.exports = __webpack_public_path__ + "static/aloopbuttontool-740b1f6b3e6b9022cd5caa93a855b86c.png";